export const periodOptions = [
  { label: 'per maand', value: 'monthly' },
  { label: 'per jaar', value: 'yearly' },
];
